/**
 * @module constants/Middleware
 */

/**
 * The exposed, namespaced User related actions.
 *
 * @note these are subject to change and need clarification
 */
export const Middleware = Object.freeze({});

export default Middleware;
